import { incaAccessor } from '@cancercentrum/inca';
export const connectionStateSelector = (state)=>state?.connection;
// Beräknande selectors
// Laddar komponenten?
export const connectionIsLoadingSelector = (state)=>{
    return !!(state?.ajaxLoader?.ConnectionLoader?.isLoading ?? true);
};
export const connectionIsLoadingFirstTimeSelector = (state)=>{
    const connectionLoaderUndefined = state?.ajaxLoader?.ConnectionLoader === undefined || state?.ajaxLoader?.ConnectionLoader.result === null;
    return connectionIsLoadingSelector(state) && connectionLoaderUndefined;
};
export const connectionIsReloadingSelector = (state)=>{
    return connectionIsLoadingSelector(state) && !connectionIsLoadingFirstTimeSelector(state);
};
export const connectionLoaderHasErrorSelector = (state)=>{
    return !!state?.ajaxLoader?.ConnectionLoader?.error;
};
export const connectablePostsSelector = (state)=>{
    const connectionState = connectionStateSelector(state);
    const connectionProps = connectionState?.connectionProps;
    const connectionInfo = parsedConnectionInfoSelector(state);
    if (!connectionProps || !connectionInfo) {
        return {
            unfilteredConnectablePosts: [],
            connectablePosts: [],
            isConnectionObliterated: false,
            lastContributedConnectable: undefined
        };
    }
    const filterConnectionVd = connectionProps.filterConnection;
    const connectableFormsFilter = connectionInfo?.connectableFormsFilter;
    const row = connectionProps?.row;
    const connectionVd = connectionInfo?.connectionVd;
    const connectablePostsVdRes = state?.ajaxLoader?.ConnectionLoader?.result?.connectablePosts ?? [];
    const errandsVdRes = state?.ajaxLoader?.ConnectionLoader?.result?.errands ?? [];
    const obliteratedConnectablePosts = connectablePostsVdRes.filter((vdItem)=>vdItem.data.MAKULERAD);
    const nonObliteratedConnectablePosts = connectablePostsVdRes.filter((vdItem)=>!vdItem.data.MAKULERAD);
    const connectableRes = filterConnectionVd(nonObliteratedConnectablePosts).map((rr)=>{
        const connectedErrand = errandsVdRes.find((err)=>err.connectedTo === rr.data.REGISTERRECORD_ID);
        const contributedErrand = errandsVdRes.find((err)=>err.contributedTo === rr.data.REGISTERRECORD_ID);
        return {
            ...rr,
            hasConnectedErrand: !!connectedErrand,
            connectedErrandPosition: connectedErrand?.data?.CURRENTPOS_FULLNAMEWITHCODE,
            hasContributingErrand: !!contributedErrand
        };
    });
    const connectablePosts = connectableRes.filter(connectableFormsFilter);
    const isConnectionObliterated = !!obliteratedConnectablePosts.find((vdItem)=>vdItem.id === row.getVdlist(connectionVd).getValue());
    // @ts-ignore lastContributedToRowId finns på form.data
    const lastContributedConnectable = nonObliteratedConnectablePosts.find((v)=>v.id === incaAccessor().form.data.lastContributedToRowId);
    return {
        unfilteredConnectablePosts: nonObliteratedConnectablePosts,
        connectablePosts,
        isConnectionObliterated,
        lastContributedConnectable
    };
};
export const completablePostsSelector = (state)=>{
    const connectionState = connectionStateSelector(state);
    const connectionProps = connectionState?.connectionProps;
    const connectionInfo = parsedConnectionInfoSelector(state);
    if (!connectionProps || !connectionInfo) {
        return {
            unfilteredCompletablePosts: [],
            completablePosts: [],
            isCompletionObliterated: false,
            lastContributedCompletable: undefined
        };
    }
    const filterCompletionVd = connectionProps.filterUpdate;
    const completableFormsFilter = connectionInfo?.completableFormsFilter;
    const row = connectionProps?.row;
    const completionVd = connectionInfo?.completionVd;
    const completablePostsVdRes = state?.ajaxLoader?.ConnectionLoader?.result?.completablePosts ?? [];
    const errandsVdRes = state?.ajaxLoader?.ConnectionLoader?.result?.errands ?? [];
    const obliteratedCompletablePosts = completablePostsVdRes.filter((vdItem)=>vdItem.data.MAKULERAD);
    const nonObliteratedCompletablePosts = completablePostsVdRes.filter((vdItem)=>!vdItem.data.MAKULERAD);
    const completableRes = filterCompletionVd(nonObliteratedCompletablePosts).map((rr)=>{
        const connectedErrand = errandsVdRes.find((err)=>err.connectedTo === rr.data.REGISTERRECORD_ID);
        const contributedErrand = errandsVdRes.find((err)=>err.contributedTo === rr.data.REGISTERRECORD_ID);
        return {
            ...rr,
            hasConnectedErrand: !!connectedErrand,
            connectedErrandPosition: connectedErrand?.data?.CURRENTPOS_FULLNAMEWITHCODE,
            hasContributingErrand: !!contributedErrand
        };
    });
    const completablePosts = completableRes.filter(completableFormsFilter);
    const isCompletionObliterated = !!obliteratedCompletablePosts.find((vdItem)=>vdItem.id === row.getVdlist(completionVd).getValue());
    // @ts-ignore lastContributedToRowId finns på form.data
    const lastContributedCompletable = nonObliteratedCompletablePosts.find((v)=>v.id === incaAccessor().form.data.lastContributedToRowId);
    return {
        unfilteredCompletablePosts: nonObliteratedCompletablePosts,
        completablePosts,
        isCompletionObliterated,
        lastContributedCompletable
    };
};
export const parsedConnectionInfoSelector = (state)=>{
    const connectionState = connectionStateSelector(state);
    return connectionState?.parsedConnectionStructure;
};
export const isIncompleteSelector = (state)=>{
    const connectionState = connectionStateSelector(state);
    const formIncompleteProps = connectionState?.formIncompleteProps;
    if (!formIncompleteProps) {
        return false;
    }
    return !!formIncompleteProps.regvar.getValue();
};
export const incompleteRegvarShortnameSelector = (state)=>{
    const connectionState = connectionStateSelector(state);
    const formIncompleteProps = connectionState?.formIncompleteProps;
    if (!formIncompleteProps) {
        return undefined;
    }
    return formIncompleteProps.regvar.$rcc.shortname;
};
export const isCompletionSelector = (state)=>{
    const connectionState = connectionStateSelector(state);
    const connectionProps = connectionState?.connectionProps;
    if (!connectionProps) {
        return false;
    }
    return !!connectionProps.regvarUpdate.getValue();
};
export const completionTypeSelector = (state)=>{
    const connectionState = connectionStateSelector(state);
    const connectionProps = connectionState?.connectionProps;
    if (!connectionState || !connectionProps || connectionProps.regvarUpdate.getValue() !== true) {
        return undefined;
    }
    if (connectionState.isDirectCompletion) return 'DIRECT';
    else {
        return 'MONITOR';
    }
};
export const completionDirectRrChangedSelector = (state)=>{
    const completionType = completionTypeSelector(state);
    const connectionState = connectionStateSelector(state);
    if (!completionType) {
        return false;
    }
    return connectionState.directCompletionRrChanged;
};
export const allowDirectUpdateDirectSaveSelector = (state)=>{
    const connectionState = connectionStateSelector(state);
    const connectionProps = connectionState?.connectionProps;
    return !!connectionProps && !!connectionProps.allowDirectUpdateDirectSave;
};
export const showForcedDisconnectModalSelector = (state)=>{
    const connectionState = connectionStateSelector(state);
    return connectionState.showForcedDisconnectModal;
};
export const connectionSourceSelector = (state)=>{
    const connectionState = connectionStateSelector(state);
    return connectionState.connectionSource;
};
export const connectedSelector = (state)=>{
    const connectionState = connectionStateSelector(state);
    const connectionProps = connectionState?.connectionProps;
    const connectionInfo = parsedConnectionInfoSelector(state);
    const connectablePosts = connectablePostsSelector(state);
    if (!connectionProps || !connectionInfo) {
        return undefined;
    }
    const connectionAndUpdateSameTable = connectionInfo?.connectionVd === connectionInfo?.completionVd;
    const connectedId = connectionProps.row.getVdlist(connectionInfo?.connectionVd)?.getValue();
    const isConnectedToDelsparad = connectablePosts.lastContributedConnectable?.id === connectedId;
    if (connectionAndUpdateSameTable) {
        if (connectionProps.regvarUpdate.getValue() !== true) {
            // Ny registrering,
            if (isConnectedToDelsparad) {
                return connectablePosts.lastContributedConnectable;
            }
            return connectablePosts.connectablePosts.find((c)=>c.id === connectedId);
        }
    } else {
        if (isConnectedToDelsparad) {
            return connectablePosts.lastContributedConnectable;
        }
        return connectablePosts.connectablePosts.find((c)=>c.id === connectedId);
    }
    return undefined;
};
export const connectedUpdateSelector = (state)=>{
    const connectionState = connectionStateSelector(state);
    const connectionProps = connectionState?.connectionProps;
    const connectionInfo = parsedConnectionInfoSelector(state);
    const completablePosts = completablePostsSelector(state);
    if (!connectionProps || !connectionInfo) {
        return undefined;
    }
    const connectionAndUpdateSameTable = connectionInfo?.connectionVd === connectionInfo?.completionVd;
    const completableId = connectionProps.row.getVdlist(connectionInfo?.completionVd)?.getValue();
    const isConnectedToDelsparad = completablePosts.lastContributedCompletable?.id === completableId;
    if (connectionAndUpdateSameTable) {
        if (connectionProps.regvarUpdate.getValue() === true) {
            // Ny registrering,
            if (isConnectedToDelsparad) {
                return completablePosts.lastContributedCompletable;
            }
            return completablePosts.completablePosts.find((c)=>c.id === completableId);
        }
    } else {
        if (isConnectedToDelsparad) {
            return completablePosts.lastContributedCompletable;
        }
        return completablePosts.completablePosts.find((c)=>c.id === completableId);
    }
    return undefined;
};
export const connectedUpdateRegistrationSelector = (state)=>{
    const connectionState = connectionStateSelector(state);
    const connectionProps = connectionState?.connectionProps;
    const connectionInfo = parsedConnectionInfoSelector(state);
    const completablePosts = completablePostsSelector(state);
    if (!connectionProps || !connectionInfo) {
        return undefined;
    }
    const completableId = connectionProps.row.getVdlist(connectionInfo?.completionVd)?.getValue();
    return completablePosts?.completablePosts.find((c)=>c.id === completableId);
};
export const directUpdateInfoSelector = (state)=>{
    const connectionState = connectionStateSelector(state);
    const connectionProps = connectionState?.connectionProps;
    const connectedUpdate = connectedUpdateSelector(state);
    if (connectionProps && connectionState.isDirectCompletion && connectedUpdate) {
        // @ts-ignore hasContributingErrand och hasConnectedErrand finns på objektet, men har ingen egen typ än
        const hasConnectedErrands = connectedUpdate.hasContributingErrand || connectedUpdate.hasConnectedErrand;
        return {
            hasConnectedErrands
        };
    } else {
        return {
            hasConnectedErrands: undefined
        };
    }
};
export const connectionSelector = (state)=>{
    const connectionState = connectionStateSelector(state);
    const allowUpdateNewRegistration = !!connectionState?.connectionProps?.allowUpdateNewRegistration;
    const allowUnconnectedSave = !!connectionState?.connectionProps?.allowUnconnectedSave;
    const connectionInfo = parsedConnectionInfoSelector(state);
    const formName = connectionInfo?.formNameCurrent;
    const formNameParent = connectionInfo?.formNameParent;
    const connectablePosts = connectablePostsSelector(state);
    const completablePosts = completablePostsSelector(state);
    const connectedTo = connectedSelector(state);
    const connectedForUpdateTo = connectedUpdateSelector(state);
    const connectedForUpdateRegistration = connectedUpdateRegistrationSelector(state);
    const directUpdateInfo = directUpdateInfoSelector(state);
    const directUpdateRrChanged = completionDirectRrChangedSelector(state);
    const connectedUpdateData = allowUpdateNewRegistration ? connectedForUpdateRegistration : connectedForUpdateTo;
    const res = {
        isLoading: connectionIsLoadingSelector(state),
        isConnected: !!connectedTo,
        connectedData: connectedTo,
        isConnectedForUpdate: !!connectedUpdateData,
        connectedUpdateData: connectedUpdateData,
        connectionSource: connectionSourceSelector(state),
        connectTo: connectionState.connectTo,
        reload: connectionState.reload,
        metadata: {
            allowUnconnectedSave,
            completablePosts: completablePosts.completablePosts,
            connectablePosts: connectablePosts.connectablePosts,
            formName: {
                parent: formNameParent,
                current: formName
            },
            isIncomplete: isIncompleteSelector(state),
            incompleteRegvarShortname: incompleteRegvarShortnameSelector(state),
            completion: {
                isCompletion: isCompletionSelector(state),
                type: completionTypeSelector(state),
                allowDirectSave: allowDirectUpdateDirectSaveSelector(state),
                hasConnectedErrands: directUpdateInfo.hasConnectedErrands,
                rrChanged: directUpdateRrChanged
            },
            showForcedDisconnectModal: showForcedDisconnectModalSelector(state)
        }
    };
    return res;
};
